var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyInsights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dbc2e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#c485f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b15793"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "50.00003 65.69409 40.7775 65.69409 40.7775 72.65338 45.38876 76.78552 50.00003 76.78552 54.61124 76.78552 59.2225 72.65338 59.2225 65.69409 50.00003 65.69409"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.94636,23.32867c-8.36975.92853-15.07001,7.78967-15.82751,16.17664-.49664,5.49847,1.49408,10.52991,4.96857,14.12158,2.21472,2.28937,3.36993,5.40216,3.36993,8.58752h2.79095v-12.81958h5.14062v12.81958h3.22211v-16.99982h5.14069v16.99982h2.79095v-.00226c0-3.25366,1.2713-6.36609,3.50769-8.72931,3.03912-3.21155,4.90619-7.54004,4.90619-12.31177,0-10.59369-9.17358-19.04468-20.01019-17.84241Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyInsights);
export default __webpack_public_path__ + "static/media/company-insights.2d924aadf5347fce8fa3f53ec85be110.svg";
export { ForwardRef as ReactComponent };